import { array } from '@mojotech/json-type-validation'

import { RegisterEntryRequest } from '@/domain/entities/reviewRequest/registerEntryRequest'
import { ReviewRequestItem } from '@/domain/entities/reviewRequest/reviewRequestItem'
import { ReviewRequestRepository } from '@/domain/repositories/reviewRequest/reviewRequestRepository'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'
import { ApiClients } from '@/infrastructure/clients/apiClients'
import { ReviewRequestItemDecoder } from '@/infrastructure/decoders/reviewRequest/reviewRequestItemDecoder'

export class ReviewRequestRepositoryImpl implements ReviewRequestRepository {
  constructor(private clients: ApiClients) {}

  async getReviewRequestList(status: string, displayLanguage: DisplayLanguageType): Promise<ReviewRequestItem[]> {
    const displayLanguageKey = displayLanguage === 'Japanese' ? 'ja' : 'en'
    const path = `review/contexts/${displayLanguageKey}/requests/statuses/${status}`
    const data = await this.clients.reviewClient.fetchAndDecode(array(ReviewRequestItemDecoder), path)
    return data
  }

  async postRegisterEntry(request: RegisterEntryRequest): Promise<void> {
    const path = `review_proxy/entry`
    await this.clients.aojClient.fetch(path, {
      method: 'POST',
      body: JSON.stringify(request)
    })
  }
}
